import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNodeId } from '@xyflow/react';
import { useDispatch } from 'react-redux';
import { setNodes, setEdges } from '~/reducers';
import { myStore } from '~/App';

// Botão de deletar
export const NodeHeaderCustomDeleteAction = () => {
    const id = useNodeId();
    const dispatch = useDispatch();
    
    const handleClick = () => {
        const currentState = myStore.getState();
        const currentNodes = currentState.nodes.nodes;
        const currentEdges = currentState.edges.edges;
        
        // Remove o nó
        const updatedNodes = currentNodes.filter(node => node.id !== id);
        
        // Encontra as arestas conectadas ao nó removido
        const connectedEdges = currentEdges.filter(
            edge => edge.source === id || edge.target === id
        );
        
        const incomingEdges = connectedEdges.filter(edge => edge.target === id);
        const outgoingEdges = connectedEdges.filter(edge => edge.source === id);
        
        let updatedEdges = currentEdges;
        
        // Se há uma aresta de entrada e pelo menos uma de saída, reconecta
        if (incomingEdges.length === 1 && outgoingEdges.length >= 1) {
            const incomingEdge = incomingEdges[0];
            const outgoingEdge = outgoingEdges[0];
            
            // Cria nova aresta conectando diretamente
            const newEdge = {
                id: `xy-edge__${incomingEdge.source}-${outgoingEdge.target}`,
                source: incomingEdge.source,
                target: outgoingEdge.target,
                style: { strokeWidth: 3, stroke: '#7b3fc0' },
                markerEnd: { type: 'arrowclosed', color: '#7b3fc0' }
            };
            
            // Preserva o sourceHandle se a aresta de entrada tinha um
            if (incomingEdge.sourceHandle) {
                newEdge.sourceHandle = incomingEdge.sourceHandle;
                
                // Aplica cor baseada no handle se for de decisão
                if (incomingEdge.sourceHandle === 'verdadeiro') {
                    newEdge.style = { ...newEdge.style, stroke: '#44ff44' };
                    newEdge.markerEnd = { ...newEdge.markerEnd, color: '#44ff44' };
                } else if (incomingEdge.sourceHandle === 'falso') {
                    newEdge.style = { ...newEdge.style, stroke: '#ff4444' };
                    newEdge.markerEnd = { ...newEdge.markerEnd, color: '#ff4444' };
                }
            }
            
            // Remove arestas conectadas ao nó e adiciona a nova
            updatedEdges = currentEdges
                .filter(edge => edge.source !== id && edge.target !== id)
                .concat(newEdge);
        } else {
            // Apenas remove as arestas conectadas ao nó
            updatedEdges = currentEdges.filter(edge => edge.source !== id && edge.target !== id);
        }
        
        // Atualiza o estado
        dispatch(setNodes(updatedNodes));
        dispatch(setEdges(updatedEdges));
    };
    
    return (
        <button title="Excluir elemento" onClick={handleClick}>
            <FontAwesomeIcon icon="fa-solid fa-trash-can" />
        </button>
    );
};
